(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name oqs.directive:oqsMessage
   * @restrict A
   * @element
   *
   * @description
   *
   * @example
   <example module="oqs">
   <file name="index.html">
   <p oqs-message="global.html.companySnippet"></p>
   </file>
   </example>
   *
   */
  angular
    .module('oqs')
    .directive('oqsMessage', oqsMessage);

  oqsMessage.$inject = ['$compile'];

  function oqsMessage($compile) {
    return {
      restrict: 'A',
      scope: {
        messageKey: '@oqsMessage'
      },
      replace: false,
      controllerAs: 'oqsMessage',
      controller: OqsMessageController,
      link: function (scope, element, attrs) {
        if ('oqsMessageHtml' in attrs) {
          element.attr('ng-bind-html', 'oqsMessage.getMessage(messageKey) | trustAsHtml');
        } else {
          element.attr('ng-bind', 'oqsMessage.getMessage(messageKey)');
        }
        element.removeAttr('oqs-message');
        $compile(element)(scope);
      },
      transclude: false
    };
  }

  OqsMessageController.$inject = ['DataService'];

  function OqsMessageController(dataService) {
    var vm = this;
    vm.getMessage = dataService.getLocaleMessage;
  }
}());
